module.exports = __webpack_public_path__ + "static/media/sport_category.b86be753.jpg";